import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils/colors";

const useStyles = makeStyles({
  root: {
    display: "flex",
    width: "100%",
    columnGap: "24px",
    padding: "16px 24px",
    boxSizing: "border-box",
  },
  panelIzquierdo: {
    flex: 0.46,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 160px)",
  },
  panelDerecho: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    minHeight: "calc(100vh - 160px)",
  },
  tituloDerecho: {
    color: colors.blueDarken,
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 24,
  },
  errorBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    height: "60vh",
    width: "100%",
    color: colors.blueDarken,
  },
  button: {
    color: colors.white,
    background: colors.blueDarken,
    borderRadius: 19,
    textTransform: "none",
    "&:hover": { background: colors.blueDarken },
  },
});

export default useStyles;
